import * as DeviceInfo from 'react-native-device-info';
import { fetchAuthSession } from 'aws-amplify/auth';
import BackendApi from './BackendApi';
import { Config } from '../../core';
import { Platform } from 'react-native';
import { getValue } from '../storage';
import moment from 'moment-timezone';
import platform from 'platform';

export const sendToKalibra = async (error: any, userAttributes: any) => {
  const isAxiosError = error.response || error.request || error.config;
  const uniqueErrors = error.error ? { customError: JSON.stringify(error) } : { axiosError: error };

  let username = 'unknown';
  let cognitoUsername = 'unknown';

  try {
    const session = await fetchAuthSession();
    const accessToken: any = session.tokens?.accessToken;
    const idToken = session.tokens?.idToken;

    if (accessToken) {
      const accessTokenPayload = accessToken.payload;
      username = String(accessTokenPayload.username || 'unknown');
    }

    if (idToken) {
      const idTokenPayload = idToken.payload;
      cognitoUsername = String(idTokenPayload['cognito:username'] || 'unknown');
    }
  } catch (err) {
    console.error('Token error: ', err);
  }

  const errorDetails = isAxiosError
    ? {
        message: error.message || 'Unknown error',
        status: error.response?.status,
        statusText: error.response?.statusText,
        method: error.config?.method?.toUpperCase(),
        url: error.config?.url,
        errorData: error.response?.data
      }
    : {
        message: error.message || JSON.stringify(error),
        type: error.error ? 'CustomError' : 'UnknownError'
      };

  const errorData = {
    timestamp: new Date().toISOString(),
    error: errorDetails,
    ...uniqueErrors,
    userInfo: {
      tenantKey: await getValue('tenantKey'),
      backend_url: await getValue('backend_url'),
      cognitoClientId: userAttributes.sub,
      email: userAttributes.email,
      username: username,
      cognitoUsername: cognitoUsername,
      userLocalTime: moment().format(),
      timezone: moment.tz.guess()
    },
    appState: {
      appCommitId: Config.GIT_COMMIT,
      appBranch: Config.APP_BRANCH
    },
    clientDeviceInfo:
      Platform.OS !== 'web'
        ? {
            deviceId: await DeviceInfo.getUniqueId(),
            deviceManufacturer: await DeviceInfo.getManufacturer(),
            deviceModel: DeviceInfo.getModel(),
            deviceSystemVersion: DeviceInfo.getSystemVersion(),
            deviceBuildNumber: DeviceInfo.getBuildNumber(),
            version: DeviceInfo.getVersion(),
            deviceName: await DeviceInfo.getDeviceName()
          }
        : {
            device: platform.name,
            deviceVersion: platform.version,
            os: {
              architecture: platform.os?.architecture,
              family: platform.os?.family,
              version: platform.os?.version
            }
          },
    clientPlatformInfo: {
      os: Platform.OS,
      version: Platform.OS !== 'web' ? Platform.Version.toString() : null
    }
  };

  const response = await BackendApi.post('/errors/send-to-kalibra', errorData);
  return response;
};
